import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddBrandModal from "../../components/modals/AddBrandModal/AddBrandModal";
import EditBrandModal from "../../components/modals/EditBrandModal/EditBrandModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import BrandsTable from "../../components/Tables/BrandsTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IBrand } from "../../types/brands.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterBrands } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const BrandsPage: React.FC = () => {
  const [brands, setBrands] = useState<IBrand[]>([]);
  const [filteredBrands, setFilteredBrands] = useState<IBrand[]>([]);
  const [editSelectedBrand, setEditSelectedBrand] = useState<IBrand | null>(
    null
  );
  const [visibleBrands, setVisibleBrands] = useState<IBrand[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddBrandModal, setIsAddBrandModal] = useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);

  const getBrands = async () => {
    try {
      const results = await authApiService.getAllBrands();

      return results;
    } catch (err) {
      console.error(err);
    }
  };
  const changeVisibiltyBrands = (brands: IBrand[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (brands) {
      const changedBrands = brands.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleBrands(changedBrands);
    }
  };

  const getOptionsFilter = () => {
    let filteredBrands = [...brands];
    // setRole(role);

    // if (role.value !== EmployeeType.NONE) {
    //   filteredUsers = filteredUsers.filter((user) => user.role === role.value);
    // }

    return filteredBrands;
  };

  const getFiltredBrands = (brands: IBrand[]) => {
    const data = getOptionsFilter();
    const filtered = filterBrands(data, searchValue);
    setFilteredBrands(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getBrands();
    if (resp) {
      setBrands(resp);
      getFiltredBrands(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredBrands.length / usersPerPage));
  }, [filteredBrands]);

  useEffect(() => {
    getFiltredBrands(brands);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, brands]);

  useEffect(() => {
    (async () => {
      const data = await getBrands();
      if (data) {
        setBrands(data);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyBrands(filteredBrands);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, brands, totalPages, filteredBrands]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={brands?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddBrandModal(true)}
            addButtonTitle="Додати бренд"
          />
        </div>
      </div>
      <BrandsTable
        brands={visibleBrands}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedBrand}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {isAddBrandModal && (
        <AddBrandModal
          onClose={() => setIsAddBrandModal(false)}
          onApply={onClickApplyModal}
        />
      )}

      {editSelectedBrand && (
        <EditBrandModal
          brand={editSelectedBrand}
          onClose={() => setEditSelectedBrand(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
    </main>
  );
};

export default BrandsPage;
